// Apolo IDE — App root.
//
// Auth gate (Epic 2) + AppShell (Epic 4). Hydrates user from token on mount.
// Sprint v6 B3: listens to the global 'apolo:openSchedule' event so ⇧⌘T
// from any surface opens the ScheduleModal.

import { useEffect, useState } from 'react';
import LoginPage from './components/LoginPage.jsx';
import AppShell from './components/AppShell.jsx';
import ScheduleModal from './components/ScheduleModal.jsx';
import { useAuthStore } from './store/useAuthStore.js';

export default function App() {
  const user = useAuthStore((s) => s.user);
  const token = useAuthStore((s) => s.token);
  const hydrateFromToken = useAuthStore((s) => s.hydrateFromToken);
  const [scheduleOpen, setScheduleOpen] = useState(false);

  useEffect(() => {
    hydrateFromToken();
  }, [hydrateFromToken]);

  useEffect(() => {
    function onOpen() { setScheduleOpen(true); }
    window.addEventListener('apolo:openSchedule', onOpen);
    return () => window.removeEventListener('apolo:openSchedule', onOpen);
  }, []);

  if (!token || !user) {
    return <LoginPage />;
  }

  return (
    <>
      <AppShell />
      <ScheduleModal open={scheduleOpen} onClose={() => setScheduleOpen(false)} />
    </>
  );
}
